// NPM
import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';

// Components
import Landing from 'Components/Pages/Landing';
import Survey from 'Components/Pages/Survey/Survey';
import Results from 'Components/Pages/Results';
import ResultsFavorites from 'Components/Pages/Results/ResultsFavorites';
import ResultsHidden from 'Components/Pages/Results/ResultsHidden';
import ResultsLoadingPage from 'Components/Pages/ResultsLoadingPage';
import ResultsErrorPage from 'Components/Pages/ResultsErrorPage';

import PasswordResetLandingPage from './Pages/Auth/PasswordResetLandingPage';
import OAuthLanding from 'Components/Pages/Auth/OAuthLanding';

// External Components
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { PrivateRoute } from 'frontend-component-library';

// CSS
import 'styles/main.css';

export class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route path="/oauth-callback/:provider" component={OAuthLanding} />

          <PrivateRoute
            redirect={!this.props.token}
            redirectTo="/"
            path="/survey"
            component={Survey}
          />
          <PrivateRoute
            exact
            redirect={!this.props.token}
            redirectTo="/"
            path="/results/hidden"
            component={ResultsHidden}
          />
          <PrivateRoute
            exact
            redirectTo="/"
            path="/results/generate"
            component={ResultsLoadingPage}
          />
          <Route exact path="/results/error" component={ResultsErrorPage} />
          <Route exact path="/results/:resultUUID" component={Results} />
          <Route
            exact
            path="/results/:resultUUID/favourites"
            component={ResultsFavorites}
          />
          <Route
            exact
            path="/password/reset/:resetToken"
            component={PasswordResetLandingPage}
          />
        </Switch>
      </Router>
    );
  }
}
function mapStateToProps(state) {
  return {
    token: state.auth.token,
  };
}

export default connect(mapStateToProps)(hot(module)(App));



// WEBPACK FOOTER //
// ./src/Components/App.js